import { render, staticRenderFns } from "./StandardsTypeahead.vue?vue&type=template&id=4ffcc144&scoped=true"
import script from "./StandardsTypeahead.vue?vue&type=script&lang=js"
export * from "./StandardsTypeahead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffcc144",
  null
  
)

export default component.exports